import { useState, useCallback } from 'react'

export const useRxChangeRequest = ({ apiClasses }) => {
  const [loading, setLoading] = useState(false)

  const requestRxChange = useCallback(async (data) => {
    if (!apiClasses?.CasesApi?.requestRxChange) {
      throw new Error('Rx-Change API not available')
    }

    setLoading(true)
    try {
      const response = await apiClasses.CasesApi.requestRxChange(data)
      
      if (response.data && response.data.success) {
        return response.data.payload
      } else {
        throw new Error('Failed to request Rx-Change')
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }, [apiClasses])

  return {
    loading,
    requestRxChange
  }
}
